import { createActions } from 'redux-actions';

const {
  setStep,
  setField,
  removeFields,
  fillRegisterSignFields,
  resetFormFieldsState,
  resetFieldsDisableState,
} = createActions(
  'SET_STEP',
  'SET_FIELD',
  'REMOVE_FIELDS',
  'FILL_REGISTER_SIGN_FIELDS',
  'RESET_FORM_FIELDS_STATE',
  'RESET_FIELDS_DISABLE_STATE'
);

export {
  setStep,
  setField,
  removeFields,
  fillRegisterSignFields,
  resetFormFieldsState,
  resetFieldsDisableState,
};
